/**
 * Primary Contact Button — Promote contact to rank 1
 */

import { Star } from 'lucide-react';

interface PrimaryContactButtonProps {
  contactId: string;
  rank: number;
  onSetPrimary: (id: string) => void;
}

export function PrimaryContactButton({ contactId, rank, onSetPrimary }: PrimaryContactButtonProps) {
  if (rank === 1) {
    return (
      <button className="p-2 rounded-lg text-amber-500" aria-label="This is the primary contact" disabled>
        <Star className="w-4 h-4" style={{ fill: 'currentColor' }} aria-hidden="true" />
      </button>
    );
  }

  return (
    <button
      onClick={() => onSetPrimary(contactId)}
      className="p-2 hover:bg-white hover:shadow-md rounded-lg text-muted-foreground hover:text-amber-500 transition-all"
      aria-label="Set as primary contact"
    >
      <Star className="w-4 h-4" aria-hidden="true" />
    </button>
  );
}
